module.exports = __webpack_public_path__ + "img/GitHub.2ef554a4.svg";